export { appClass };
import Vue from "vue";
import App from "../App.vue";
import { router } from "../router/router";
import { store } from "@/store/store";
import { eventBus } from "@/eventBus";
import i18n from '../plugins/i18n';
import lazyLoad from '../directives/lazyLoad.js'; // Import the directive

Vue.directive('lazyload', lazyLoad); // Register the directive globally

// router.beforeEach((to, from, next) => {
//   if (!to.matched.length) {
//     console.log("route not found");
//   } else {
//     next();
//   }
// });
class appClass {
  constructor() {
    import(
      /* webpackChunkName: "configClass" */ /* webpackMode: "lazy" */ "./configClass"
    ).then(config => {
      this.config = new config.configClass();
      this.config.loadConfig();
      // window?.bitmovin?.playerui?.i18n?.setConfig({
      //   language: 'es'
      // });
     
    });
    eventBus.$on("configLoaded", this.loadVue);
  }

  loadVue() {
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  }
}
